import { render, staticRenderFns } from "./faq.vue?vue&type=template&id=37bd1a58&scoped=true&"
import script from "./faq.vue?vue&type=script&lang=ts&"
export * from "./faq.vue?vue&type=script&lang=ts&"
import style0 from "./faq.scss?vue&type=style&index=0&id=37bd1a58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bd1a58",
  null
  
)

component.options.__file = "faq.vue"
export default component.exports